import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Hoot from "./Hoot";
import { RiLockPasswordLine } from "react-icons/ri";
import { PiSignInBold } from "react-icons/pi";
import { FaRegEnvelope } from "react-icons/fa6";

axios.defaults.withCredentials = true;

const SLIDER_IMAGES = [ 
  "https://ik.imagekit.io/zks5iegia/510979955_122246090972025506_4665925908346494108_n.jpg?updatedAt=1786883550143", 
];

const loginStyles = `
:root{
  --primary:#6052ff;
  --bg:#f5f5ff;
  --card:#ffffff;
  --muted:#6b7280;
  --text:#111827;
  --border:#e5e7eb;
  --danger:#b91c1c;
  --success:#15803d;
}
*{box-sizing:border-box;}
html,body{height:100%;}
body{
  font-family:"Montserrat",system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  color:var(--text);
}

.auth-page-wrapper{
  min-height:100vh;
  background:#fff;
  display:flex;
}

.login-shell{
  width:100%;
  display:grid;
  grid-template-columns: minmax(0,1fr) minmax(0,1fr);
  gap:0;
  background:#fff;
  min-height:100vh;
}
@media (max-width:860px){
  .login-shell{ grid-template-columns:1fr; }
  .login-visual{ display:none; }
}

/* -------- LEFT: FORM -------- */
.login-form-side{
  padding:56px 48px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}
.login-form-content{
  width:100%;
  max-width:500px;
}
.login-brand{
  display:flex;
  align-items:center;
  gap:10px;
  margin-bottom:36px;
}
.login-brand-icon{
  width:34px;height:34px;border-radius:10px;
  overflow:hidden;
  display:inline-grid;place-items:center;
  background:#f2f1ff;
}
.login-brand-icon img{ width:100%; height:100%; object-fit:contain; }
.login-brand-text{
  font-weight:900;
  font-size:1.02rem;
  color:var(--text);
}

.login-title{
  font-size:2rem;
  font-weight:900;
  line-height:1.2;
  margin:0 0 8px;
  color:var(--text);
}
.login-subtitle{
  font-size:.94rem;
  color:var(--muted);
  margin-bottom:28px;
}

.form-label{
  font-size:.8rem !important;
  font-weight:700 !important;
  color:var(--text) !important;
}
.form-control{
  background:#ffffff !important;
  border-radius:999px !important;
  border:1px solid var(--border) !important;
  font-size:.9rem !important;
  color:var(--text) !important;
  padding:.62rem 1rem !important;
}
.form-control:focus{
  border-color:var(--primary) !important;
  box-shadow:0 0 0 3px rgba(96,82,255,.15) !important;
  background:#ffffff !important;
}
.input-group-text{
  background:#ffffff !important;
  border-radius:999px 0 0 999px !important;
  border:1px solid var(--border) !important;
  border-right:0 !important;
  color:#9ca3af !important;
}
.form-control.round-right{
  border-radius:0 999px 999px 0 !important;
  border-left:0 !important;
}

.btn-primary{
  border-radius:999px !important;
  border:none !important;
  font-size:.95rem !important;
  font-weight:800 !important;
  padding:.68rem 1rem !important;
  background:linear-gradient(135deg,var(--primary),#7c3aed) !important;
}
.btn-primary:hover{ filter:brightness(1.05); }

.link-muted{
  color:var(--muted);
  font-size:.86rem;
}
.link-muted a{
  color:#4f46e5;
  text-decoration:none;
  font-weight:700;
}
.link-muted a:hover{text-decoration:underline;}

.remember-row{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:20px;
}
.remember-row .form-check-label{
  font-size:.85rem;
  color:var(--muted);
}
.forgot-link{
  font-size:.85rem;
  font-weight:700;
  color:#4f46e5;
  text-decoration:none;
}
.forgot-link:hover{ text-decoration:underline; }

.error-text{
  color:var(--danger);
  font-size:.82rem;
  font-weight:700;
  background:rgba(185, 28, 28, 0.06);
  border:1px solid rgba(185, 28, 28, 0.18);
  padding:10px 12px;
  border-radius:14px;
}
.success-text{
  color:var(--success);
  font-size:.82rem;
  font-weight:700;
  background:rgba(21, 128, 61, 0.06);
  border:1px solid rgba(21, 128, 61, 0.18);
  padding:10px 12px;
  border-radius:14px;
}

.login-footer-note{
  font-size:.78rem;
  color:var(--muted);
  margin-top:32px;
}

/* -------- RIGHT: VISUAL / SLIDER -------- */
.login-visual{
  position:relative;
  background:#000;
  padding:48px;
  display:flex;
  flex-direction:column;
  justify-content:flex-end;
  overflow:hidden;
}
.login-visual-copy{
  position:relative;
  z-index:2;
  color:#fff;
}
.login-visual-badge{
  display:inline-flex;
  align-items:center;
  gap:.35rem;
  padding:.3rem .75rem;
  border-radius:999px;
  background:rgba(255,255,255,.08);
  border:1px solid rgba(255,255,255,.22);
  font-size:.72rem;
  font-weight:700;
  letter-spacing:.02em;
  margin-bottom:16px;
}
.login-visual-title{
  font-size:1.6rem;
  font-weight:900;
  line-height:1.25;
  margin:0 0 10px;
}
.login-visual-subtitle{
  font-size:.9rem;
  line-height:1.5;
  color:rgba(255,255,255,.82);
  max-width:380px;
}

.slider-track{
  position:absolute;
  inset:0;
  z-index:0;
}
.slider-slide{
  position:absolute;
  inset:0;
  background-size:cover;
  background-position:center;
  opacity:0;
  transition:opacity 1.4s ease-in-out;
}
.slider-slide.active{
  opacity:1;
}
.slider-overlay{
  position:absolute;
  inset:0;
  z-index:1;
  background:linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 40%, rgba(0,0,0,.88) 100%);
}
.slider-dots{
  position:relative;
  z-index:2;
  display:flex;
  gap:6px;
  margin-top:22px;
}
.slider-dot{
  width:22px;
  height:4px;
  border-radius:999px;
  background:rgba(255,255,255,.3);
  transition:background .3s ease;
}
.slider-dot.active{
  background:#fff;
}
`;

function useImageSlider(images, intervalMs = 4500) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length < 2) return;
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [images, intervalMs]);

  return activeIndex;
}

function SliderBackground({ images, activeIndex }) {
  return (
    <>
      <div className="slider-track">
        {images.map((src, idx) => (
          <div
            key={src}
            className={`slider-slide${idx === activeIndex ? " active" : ""}`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
      </div>
      <div className="slider-overlay" />
    </>
  );
}

function SliderDots({ images, activeIndex }) {
  return (
    <div className="slider-dots">
      {images.map((src, idx) => (
        <span
          key={src}
          className={`slider-dot${idx === activeIndex ? " active" : ""}`}
        />
      ))}
    </div>
  );
}

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Importante: mensagens genéricas (evita "dar pistas" a utilizadores desconhecidos)
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const activeSlide = useImageSlider(SLIDER_IMAGES);

  const navigate = useNavigate();

  // Verificar se o utilizador já tem sessão
  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        await axios.get(Hoot() + "me", { withCredentials: true });
        setIsLoggedIn(true);
        navigate("/dashboard");
      } catch (err) {
        // Não mostramos detalhes técnicos no ecrã de login
        console.log(err);
        setIsLoggedIn(false);
      }
    };

    checkLoginStatus();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await axios.post(
        Hoot() + "login",
        { email, password },
        { withCredentials: true }
      );

      setSuccess("Sessão iniciada. A redirecionar…");
      console.clear();
      setTimeout(() => navigate("/dashboard"), 800);
    } catch (err) {
      console.log(err);

      // Mensagem SEMPRE genérica para não permitir "enumeração" (email existe/não existe, etc.)
      const isNetwork = !err?.response;
      setError(
        isNetwork
          ? "Não foi possível ligar ao servidor. Tenta novamente."
          : "Não foi possível iniciar sessão. Verifica as credenciais e tenta novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit(e);
  };

  if (isLoggedIn) return null;

  return (
    <>
      <style>{loginStyles}</style>

      <div className="auth-page-wrapper">
        <div className="login-shell">
          {/* LADO ESQUERDO — FORMULÁRIO */}
          <div className="login-form-side">
          <div className="login-form-content">
            <div className="login-brand">
              <div className="login-brand-icon">
                <img
                  src="https://ik.imagekit.io/zks5iegia/image-gen__2___1_-removebg-preview%20(1).png"
                  alt=""
                />
              </div>
              <div className="login-brand-text">Eduall</div>
            </div>

            <h1 className="login-title">Bem-vindo de volta</h1>
            <p className="login-subtitle">
              Introduz as tuas credenciais para acederes ao painel de gestão.
            </p>

            <Form onSubmit={handleSubmit}>
              {error && <div className="mb-3 error-text">{error}</div>}
              {success && <div className="mb-3 success-text">{success}</div>}

              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email</Form.Label>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaRegEnvelope />
                  </span>
                  <Form.Control
                    type="email"
                    className="round-right"
                    placeholder="nome@dominio.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-2" controlId="formBasicPassword">
                <Form.Label>Palavra-passe</Form.Label>
                <div className="input-group">
                  <span className="input-group-text">
                    <RiLockPasswordLine />
                  </span>
                  <Form.Control
                    type="password"
                    className="round-right"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoComplete="current-password"
                    required
                  />
                </div>
              </Form.Group>

              <div className="remember-row">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="remember" />
                  <label className="form-check-label" htmlFor="remember">
                    Manter sessão iniciada
                  </label>
                </div>
                <a href="#" className="forgot-link" onClick={(e) => e.preventDefault()}>
                  Esqueceste-te da password?
                </a>
              </div>

              <Button
                variant="primary"
                className="w-100 mb-3"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <>
                    Entrar <PiSignInBold />
                  </>
                )}
              </Button>

              <div className="link-muted text-center">
                Precisas de acesso?{" "}
                <a href="#" onClick={(e) => e.preventDefault()}>
                  Contacta o administrador.
                </a>
              </div>
            </Form>

            <div className="login-footer-note">© 2026 Eduall. Todos os direitos reservados.</div>
          </div>
          </div>

          {/* LADO DIREITO — VISUAL COM SLIDER */}
          <div className="login-visual">
            <SliderBackground images={SLIDER_IMAGES} activeIndex={activeSlide} />
            <div className="login-visual-copy">
              <span className="login-visual-badge">Área Reservada • Eduall</span>
              <h2 className="login-visual-title">
                Gestão simples, decisões mais inteligentes.
              </h2>
              <p className="login-visual-subtitle">
                Acesso protegido e sessão segura para a tua equipa gerir tudo
                num único painel centralizado.
              </p>
              <SliderDots images={SLIDER_IMAGES} activeIndex={activeSlide} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

/* Opcional: mantive o SessionTester como estava */
const SessionTester = () => {
  const [numero, setNumero] = useState(null);
  const [mensagem, setMensagem] = useState("");

  const armazenarNumero = async () => {
    try {
      const res = await axios.post(Hoot() + "store-random", {});
      setNumero(res.data.number);
      setMensagem(res.data.msg);
    } catch (error) {
      setMensagem("Erro ao armazenar número.");
      console.error(error);
    }
  };

  const obterNumero = async () => {
    try {
      const res = await axios.get(Hoot() + "all-managers");
      console.log(res.data);
      setNumero(res.data.number);
      setMensagem("Número obtido com sucesso.");
    } catch (error) {
      setMensagem("Erro ao obter número ou número não encontrado.");
      setNumero(null);
      console.error(error);
    }
  };

  useEffect(() => {
    obterNumero();
  }, []);

  return (
    <div>
      <h2>Teste de Sessão</h2>
      <button onClick={armazenarNumero}>Armazenar Número Aleatório</button>
      <button onClick={obterNumero}>Obter Número da Sessão</button>
      {mensagem && <p>{mensagem}</p>}
      {numero !== null && <p>Número: {numero}</p>}
    </div>
  );
};

export default Login;